import { Injectable, TemplateRef } from '@angular/core';
import { Article } from './models/article';
import { Personne } from './models/personne';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  public depotModal: TemplateRef<any>;
  public personneModal: TemplateRef<any>;
  public achatModal: TemplateRef<any>;
  public soldeModal: TemplateRef<any>;
  public articlesVendus: Article[] = [];
  public marques: string[] = ["HEAD", "SCOTT", "KERMA", "SNC"];
  public types: string[] = ["BATON", "ACCESSOIRE", "CHAUSSURE FOND", "CHAUSSURE ALPIN"];
  
  public clients: Personne[] = [
    {num: '1', nom:"Casté", prenom:"Roro", adresse: "rue de Dijon", cp: "21220", ville: "Fixin", mail:"roro@roro.com", telephone: "9999999999", type:"Particulier"},
    {num: '2', nom:"Castou", prenom:"Rara", adresse: "rue de Talant", cp: "21160", ville: "Marsannay-la-Côte", mail:"rara@rara.com", telephone: "00000000", type:"Professionel"},
    {num: '3', nom:"Dan", prenom:"Lord", adresse: "rue de Fixin", cp: "21000", ville: "Dijon", mail:"lord@lord.com", telephone: "111111111", type:"Sans"}
  ]

  public articles: Article[] = [
    {num:"1", type:"BATON", marque: "KERMA", modele: "Droit", taille: "115cm", couleur:"Noir", prixVente: "5.00", fraisDepot:"1.50", numDepot: "0001", dateDepot: new Date(),
    vendeur: {num: '1', nom:"Casté", prenom:"Roro", adresse: "rue de Dijon", cp: "21220", ville: "Fixin", mail:"roro@roro.com", telephone: "9999999999", type:"Particulier"},
    acheteur: new Personne()},
    {num:"2", type:"CHAUSSURE DE SKI", marque: "Technica", modele: "Mach1", taille: "26.5", couleur:"Noir", prixVente: "50.00", fraisDepot:"2.00", numDepot: "0001", dateDepot: new Date(),
    vendeur: {num: '1', nom:"Casté", prenom:"Roro", adresse: "rue de Dijon", cp: "21220", ville: "Fixin", mail:"roro@roro.com", telephone: "9999999999", type:"Particulier"},
    acheteur: new Personne()},
    {num:"3", type:"SKI", marque: "HEAD", modele: "Magnum", taille: "163cm", couleur:"Vert/Noir", prixVente: "100.00", fraisDepot:"5.75", numDepot: "0001", dateDepot: new Date(),
    vendeur: {num: '3', nom:"Dan", prenom:"Lord", adresse: "rue de Fixin", cp: "21000", ville: "Dijon", mail:"lord@lord.com", telephone: "111111111", type:"Sans"},
    acheteur: new Personne()}
  ]

  public articlesNonVendus: Article[] = [
    {num:"1", type:"BATON", marque: "KERMA", modele: "Droit", taille: "115cm", couleur:"Noir", prixVente: "5.00", fraisDepot:"1.50", numDepot: "0001", dateDepot: new Date(),
    vendeur: {num: '1', nom:"Casté", prenom:"Roro", adresse: "rue de Dijon", cp: "21220", ville: "Fixin", mail:"roro@roro.com", telephone: "9999999999", type:"Particulier"},
    acheteur: new Personne()},
    {num:"2", type:"CHAUSSURE DE SKI", marque: "Technica", modele: "Mach1", taille: "26.5", couleur:"Noir", prixVente: "50.00", fraisDepot:"2.00", numDepot: "0001", dateDepot: new Date(),
    vendeur: {num: '1', nom:"Casté", prenom:"Roro", adresse: "rue de Dijon", cp: "21220", ville: "Fixin", mail:"roro@roro.com", telephone: "9999999999", type:"Particulier"},
    acheteur: new Personne()},
    {num:"3", type:"SKI", marque: "HEAD", modele: "Magnum", taille: "163cm", couleur:"Vert/Noir", prixVente: "100.00", fraisDepot:"5.75", numDepot: "0001", dateDepot: new Date(),
    vendeur: {num: '3', nom:"Dan", prenom:"Lord", adresse: "rue de Fixin", cp: "21000", ville: "Dijon", mail:"lord@lord.com", telephone: "111111111", type:"Sans"},
    acheteur: new Personne()}
  ]

  constructor() { }

  
}
